// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCfrVD4MgN4CdMRabbTQCpGh59ZRSRR6mU",
  authDomain: "epcspark-3ce7a.firebaseapp.com",
  projectId: "epcspark-3ce7a",
  storageBucket: "epcspark-3ce7a.firebasestorage.app",
  messagingSenderId: "17673556258",
  appId: "1:17673556258:web:3f66c96bfe577b3b89557b",
  measurementId: "G-F4KQ0NHTC6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);
export { auth };

// Export the app instance as well (in case you need it)
export default app; 